import get from 'mout/object/get';

import featureTests from './feature-tests';

export default function hasFeature(feature) {
  return get(featureTests, feature);
}
